






































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const Debtors = namespace("DebtorsModule");

@Component({
  name: "DebtorDetails",
})
export default class DebtorDetails extends Vue {
  @Debtors.State
  public debtorData!: Array<any>;

  @Debtors.Action
  public retrieveDebtorById!: (params: number) => Promise<any>;

  public debtor = {
    AdmNr: 0,
    Debtor: 0,
    Name: "",
    SearchCode: "",
    Country: "",
    PostalCode: "",
    Address1: "",
    City: "",
    Telephone: "",
    Email: "",
    BankInfo: [
      {
        BankAccType: "",
        BankAccNr: "",
        BankCurrCode: "",
        BankTypePrimary: 0,
        BankName: "",
        BankSwiftAddress: "",
      },
    ],
    CustomField: {
      MainContactName: "",
      MainContactEmail: "",
      DutchCompany: "",
      Tax: "",
      RegisterName: "",
      InvoiceType: [],
      VAT: "",
    },
  };
  backToDebtor() {
    this.$router.push({ name: "Debtor" });
  }
  getDebtorDetailData() {
    this.retrieveDebtorById(parseInt(this.$route.params.debtorId)).then(
      (response) => {
        if (!response.CustomField) {
          response.CustomField = {
            MainContactName: "",
            MainContactEmail: "",
            RegisterName: "",
            InvoiceType: [],
          };
        }
        this.debtor = response;
      }
    );
  }
  created() {
    this.getDebtorDetailData();
  }
}
